import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';
import { EligibilityResult } from '@/queries/products/types';
import { useSelector } from '@/redux/helper';

interface ProductEligibilityResultProps extends ComponentProps<'p'> {
  result: EligibilityResult | undefined;
}

const ProductEligibilityResult = ({ result, className, ...props }: ProductEligibilityResultProps) => {
  const logged = useSelector((state) => state.user.logged);

  const reason = result?.allowed ? null : !logged ? (
    <>
      Please <a href="/login">login</a> first
    </>
  ) : (
    result?.reason ?? 'You are not eligible for this product.'
  );

  if (!reason) return null;

  return (
    <p
      className={cn('preflight preflight-p mx-4 max-w-[274px] text-center text-sm text-secondary-green', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {reason}
    </p>
  );
};

export default ProductEligibilityResult;
